import React, { useEffect, useState, useRef as _useRef, useCallback } from 'react';
import authService from '../../services/authService';
import './Admin.css';
import { useState as _useState } from 'react';
import AdminModels from './AdminModels';
import AdminUsage from './AdminUsage';
import AdminBilling from './AdminBilling';
import AdminDocsEdit from './AdminDocsEdit';
import AdminRegistration from './AdminRegistration';
import AppPasswordPolicy from './AppPasswordPolicy';
import ScriptGovernanceTab from './ScriptGovernanceTab';
import Toast from '../Toast';
import { getTabStyles, getTabHoverStyles, restoreTabStyles } from '../../utils/tabColors';

const InviteUserPanel = ({ onInvited }) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [roles, setRoles] = useState(''); // comma-separated
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [link, setLink] = useState('');
  const [copyMsg, setCopyMsg] = useState('');
  const [sendEmail, setSendEmail] = useState(true);
  const [emailStatus, setEmailStatus] = useState('');
  const invite = async () => {
    try {
      setBusy(true); setError(''); setLink(''); setEmailStatus('');
      const t = authService.getToken();
      const body = { email: email.trim(), firstName: firstName.trim() || null, lastName: lastName.trim() || null, roles: roles ? roles.split(',').map(r=>r.trim()).filter(Boolean) : [], sendEmail: !!sendEmail };
      const r = await fetch('/api/admin/users/invite', { method:'POST', headers:{ Authorization:`Bearer ${t}`, 'Content-Type':'application/json' }, body: JSON.stringify(body) });
      const j = await r.json().catch(()=>({}));
      if (!r.ok) { setError(j?.message || 'Failed to invite'); return; }
      setLink(j.resetLink || '');
      if (j.emailed) setEmailStatus('Email sent.');
      else if (sendEmail && j.emailError) setEmailStatus(`Email not sent: ${j.emailError}`);
      if (onInvited) onInvited();
    } catch (e) {
      setError(e.message || 'Failed');
    } finally { setBusy(false); }
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopyMsg('Copied!'); setTimeout(()=>setCopyMsg(''), 900);
    } catch {}
  };
  return (
    <div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:8 }}>
        <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
          <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Email</span>
          <input 
            type="email" 
            value={email} 
            onChange={e=>setEmail(e.target.value)} 
            placeholder="user@example.com"
            style={{
              padding: '10px 12px',
              border: '1.5px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              background: '#fff',
              width: '100%',
              boxSizing: 'border-box'
            }}
            onFocus={(e)=>{
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={(e)=>{
              e.target.style.borderColor = '#e5e7eb';
              e.target.style.boxShadow = 'none';
            }}
          />
        </label>
        <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
          <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>First Name</span>
          <input 
            value={firstName} 
            onChange={e=>setFirstName(e.target.value)}
            style={{
              padding: '10px 12px',
              border: '1.5px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              background: '#fff',
              width: '100%',
              boxSizing: 'border-box'
            }}
            onFocus={(e)=>{
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={(e)=>{
              e.target.style.borderColor = '#e5e7eb';
              e.target.style.boxShadow = 'none';
            }}
          />
        </label>
        <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
          <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Last Name</span>
          <input 
            value={lastName} 
            onChange={e=>setLastName(e.target.value)}
            style={{
              padding: '10px 12px',
              border: '1.5px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              background: '#fff',
              width: '100%',
              boxSizing: 'border-box'
            }}
            onFocus={(e)=>{
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={(e)=>{
              e.target.style.borderColor = '#e5e7eb';
              e.target.style.boxShadow = 'none';
            }}
          />
        </label>
        <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
          <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Roles (comma)</span>
          <input 
            value={roles} 
            onChange={e=>setRoles(e.target.value)} 
            placeholder="OrgAdmin, PaidUser"
            style={{
              padding: '10px 12px',
              border: '1.5px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              background: '#fff',
              width: '100%',
              boxSizing: 'border-box'
            }}
            onFocus={(e)=>{
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={(e)=>{
              e.target.style.borderColor = '#e5e7eb';
              e.target.style.boxShadow = 'none';
            }}
          />
        </label>
      </div>
      <div className="admin-controls" style={{ marginTop:8 }}>
        <label style={{ display:'flex', alignItems:'center', gap:6 }}>
          <input type="checkbox" checked={sendEmail} onChange={e=>setSendEmail(e.target.checked)} />
          <span>Send invite email</span>
        </label>
        <button 
          onClick={invite} 
          disabled={busy || !email.trim()}
          style={{
            padding: '10px 20px',
            background: (busy || !email.trim()) ? '#9ca3af' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: (busy || !email.trim()) ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: (busy || !email.trim()) ? 'none' : '0 2px 4px rgba(102, 126, 234, 0.2)',
            opacity: (busy || !email.trim()) ? 0.7 : 1
          }}
          onMouseEnter={(e)=>{
            if (!busy && email.trim()) {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
            }
          }}
          onMouseLeave={(e)=>{
            if (!busy && email.trim()) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
            }
          }}
        >
          {busy ? 'Inviting…' : 'Generate Invite Link'}
        </button>
        {error && <span style={{ color:'#b00020', marginLeft:8 }}>{error}</span>}
        {emailStatus && <span style={{ color: emailStatus.startsWith('Email sent') ? '#065f46' : '#b45309', marginLeft:8 }}>{emailStatus}</span>}
      </div>
      {link && (
        <div style={{ marginTop:10, display:'grid', gridTemplateColumns:'1fr auto', gap:8 }}>
          <input 
            value={link} 
            readOnly 
            style={{ 
              width:'100%',
              padding: '10px 12px',
              border: '1.5px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '14px',
              background: '#f9fafb',
              color: '#6b7280',
              boxSizing: 'border-box'
            }}
          />
          <button 
            onClick={copy}
            style={{
              padding: '10px 16px',
              background: '#fff',
              color: '#667eea',
              border: '1.5px solid #667eea',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e)=>{
              e.target.style.background = '#667eea';
              e.target.style.color = '#fff';
            }}
            onMouseLeave={(e)=>{
              e.target.style.background = '#fff';
              e.target.style.color = '#667eea';
            }}
          >
            Copy
          </button>
          {copyMsg && <div style={{ color:'#059669' }}>{copyMsg}</div>}
        </div>
      )}
    </div>
  );
};

const PromptPreviewModal = ({ id, onClose }) => {
  const [loading, setLoading] = _useState(true);
  const [error, setError] = _useState('');
  const [prompt, setPrompt] = _useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const headers = authService.getAuthHeaders();
        const res = await fetch(`/api/savedprompts/${id}`, { 
          headers: { ...headers, 'Content-Type': 'application/json' },
          credentials: 'include'
        });
        if (!res.ok) {
          if (res.status === 401) {
            authService.logout();
            window.location.href = '/login';
            return;
          }
          throw new Error('Failed to load prompt');
        }
        const data = await res.json().catch(() => null);
        if (!data) throw new Error('Invalid response format');
        setPrompt(data);
      } catch (e) {
        setError(e.message || 'Failed to load prompt');
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]); // setError, setLoading, setPrompt are stable setState functions

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>×</button>
        {loading ? <div>Loading...</div> : error ? <div className="error-message">{error}</div> : (
          <div>
            <h3 style={{marginTop:0}}>{prompt.title}</h3>
            <pre style={{whiteSpace:'pre-wrap'}}>{prompt.content}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

const policyGroups = [
  { title: 'Content Safety & Legal', items: [
    { code: '1a', label: 'Vulgar/profane' },
    { code: '1b', label: 'Hate/harassment' },
    { code: '1c', label: 'Adult/minors' },
    { code: '1d', label: 'Violence/self-harm' },
    { code: '1e', label: 'Illegal/harm' },
    { code: '1f', label: 'Copyright/plagiarism' }
  ]},
  { title: 'Privacy & Security', items: [
    { code: '2a', label: 'Personal information' },
    { code: '2b', label: 'Confidential/business' },
    { code: '2c', label: 'Vulnerabilities/malicious' },
    { code: '2d', label: 'Social engineering/phishing' }
  ]},
  { title: 'Platform Quality & Spam', items: [
    { code: '3a', label: 'Spam/low-quality' },
    { code: '3b', label: 'Duplicates' },
    { code: '3c', label: 'Misleading' },
    { code: '3d', label: 'Commercial spam' }
  ]},
  { title: 'Community Standards', items: [
    { code: '4a', label: 'ToS violation' },
    { code: '4b', label: 'Off-topic' },
    { code: '4c', label: 'Jailbreak/abuse' }
  ]},
  { title: 'User Reports', items: [
    { code: '5a', label: 'Multiple user flags' },
    { code: '5b', label: 'Harmful misinformation' }
  ]}
];

const CodesDropdown = ({ id, value, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(() => (value ? value.split(',').map(v=>v.trim()).filter(Boolean) : []));
  const summary = selected.join(', ') || 'Select codes';

  const toggle = () => setOpen(o=>!o);
  const onChange = (code, checked) => {
    setSelected(prev => {
      const set = new Set(prev);
      if (checked) set.add(code); else set.delete(code);
      return Array.from(set).sort();
    });
  };
  const save = async () => {
    const t = authService.getToken();
    await fetch(`/api/admin/moderation/prompts/${id}/update`, { method:'POST', headers:{Authorization:`Bearer ${t}`, 'Content-Type':'application/json'}, body: JSON.stringify({ moderationCodes: selected.join(',') })});
    setOpen(false);
    onSaved && onSaved(selected.join(','));
  };

  return (
    <div className="codes-dd">
      <button type="button" className="codes-btn" onClick={toggle}>{summary} ▾</button>
      {open && (
        <div className="codes-menu">
          {policyGroups.map(group => (
            <div key={group.title} className="codes-group">
              <div className="codes-group-title">{group.title}</div>
              {group.items.map(item => (
                <label key={item.code} className="codes-item">
                  <input type="checkbox" checked={selected.includes(item.code)} onChange={e=>onChange(item.code, e.target.checked)} />
                  <span className="codes-code">{item.code}</span> {item.label}
                </label>
              ))}
            </div>
          ))}
          <div className="codes-actions">
            <button type="button" onClick={()=>setOpen(false)}>Cancel</button>
            <button type="button" className="primary" onClick={save}>Save</button>
          </div>
        </div>
      )}
    </div>
  );
};

const EnterpriseLimitLocal = () => {
  const [val, setVal] = useState(() => {
    try {
      const raw = localStorage.getItem('enterprise_limit_max');
      const n = parseInt(raw || '', 10);
      return isNaN(n) ? 15 : n;
    } catch { return 15; }
  });
  const [saved, setSaved] = useState(false);
  const onSave = () => {
    try { localStorage.setItem('enterprise_limit_max', String(Math.max(1, parseInt(String(val), 10) || 15))); } catch {}
    setSaved(true);
    setTimeout(()=>setSaved(false), 1200);
  };
  const onReset = () => {
    try { localStorage.removeItem('enterprise_limit_max'); } catch {}
    setVal(15);
  };
  return (
    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
      <input 
        type="number" 
        min={1} 
        max={60} 
        value={val} 
        onChange={(e)=>setVal(parseInt(e.target.value||'15',10)||15)}
        style={{
          width:120,
          padding: '10px 12px',
          border: '1.5px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '14px',
          transition: 'all 0.2s ease',
          background: '#fff',
          boxSizing: 'border-box'
        }}
        onFocus={(e)=>{
          e.target.style.borderColor = '#667eea';
          e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
        }}
        onBlur={(e)=>{
          e.target.style.borderColor = '#e5e7eb';
          e.target.style.boxShadow = 'none';
        }}
      />
      <button 
        onClick={onSave}
        style={{
          padding: '10px 20px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 4px rgba(102, 126, 234, 0.2)'
        }}
        onMouseEnter={(e)=>{
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
        }}
        onMouseLeave={(e)=>{
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
        }}
      >
        Save
      </button>
      <button 
        onClick={onReset}
        style={{
          padding: '10px 20px',
          background: '#fff',
          color: '#6b7280',
          border: '1.5px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e)=>{
          e.target.style.background = '#f3f4f6';
          e.target.style.borderColor = '#d1d5db';
        }}
        onMouseLeave={(e)=>{
          e.target.style.background = '#fff';
          e.target.style.borderColor = '#e5e7eb';
        }}
      >
        Reset
      </button>
      {saved && <span style={{ color:'#059669' }}>Saved</span>}
    </div>
  );
};

const Admin = () => {
  const [metrics, setMetrics] = useState(null);
  const [error, setError] = useState('');
  const [tab, setTab] = useState('overview');
  const [userPage, setUserPage] = useState({ total: 0, page: 1, pageSize: 10, users: [] });
  const [flaggedPage, setFlaggedPage] = useState({ total: 0, page: 1, pageSize: 10, items: [] });
  const [sinceDate, setSinceDate] = useState('');
  const [previewPromptId, setPreviewPromptId] = useState(null);
  const [pricing, setPricing] = useState([]);
  const [editingPrice, setEditingPrice] = useState(null);
  
  // Toast state for Teams/Orgs tab
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });
  const showToast = (message, type = 'success') => setToast({ show: true, type, message });
  const hideToast = () => setToast(prev => ({ ...prev, show: false }));
  
  // Teams/Orgs form state
  const [teamName, setTeamName] = useState('');
  const [teamSlug, setTeamSlug] = useState('');
  const [teamSlugManuallyEdited, setTeamSlugManuallyEdited] = useState(false);
  const [orgName, setOrgName] = useState('');
  const [orgSlug, setOrgSlug] = useState('');
  const [orgSlugManuallyEdited, setOrgSlugManuallyEdited] = useState(false);
  const [creatingTeam, setCreatingTeam] = useState(false);
  const [creatingOrg, setCreatingOrg] = useState(false);
  
  // Slugify helper function
  const slugify = (s) => {
    try {
      return (s || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-+/g, '-');
    } catch { return ''; }
  };
  
  // Auto-generate team slug from name
  // Always update slug to mirror the name, including when name is cleared
  useEffect(() => {
    if (!teamSlugManuallyEdited) {
      setTeamSlug(slugify(teamName));
    }
  }, [teamName, teamSlugManuallyEdited]);
  
  // Auto-generate org slug from name
  // Always update slug to mirror the name, including when name is cleared
  useEffect(() => {
    if (!orgSlugManuallyEdited) {
      setOrgSlug(slugify(orgName));
    }
  }, [orgName, orgSlugManuallyEdited]);
  
  // Create team with duplicate slug handling
  const createTeam = async () => {
    if (!teamName.trim()) {
      showToast('Team name is required', 'error');
      return;
    }
    setCreatingTeam(true);
    try {
      const t = authService.getToken();
      let slug = teamSlug.trim() || slugify(teamName);
      let attempt = 0;
      const maxAttempts = 100;
      
      while (attempt < maxAttempts) {
        const currentSlug = attempt === 0 ? slug : `${slug}-${String(attempt).padStart(2, '0')}`;
        const r = await fetch('/api/admin/teams', { 
          method: 'POST', 
          headers: { Authorization: `Bearer ${t}`, 'Content-Type': 'application/json' }, 
          body: JSON.stringify({ name: teamName.trim(), slug: currentSlug }) 
        });
        
        if (r.ok) {
          showToast(`Team "${teamName}" created successfully with slug: ${currentSlug}`, 'success');
          setTeamName('');
          setTeamSlug('');
          setTeamSlugManuallyEdited(false);
          return;
        }
        
        const err = await r.json().catch(() => ({}));
        // Check if error is due to duplicate slug
        if (err?.message?.toLowerCase().includes('slug already exists') || r.status === 400) {
          attempt++;
          continue;
        }
        
        // Other error - break and show message
        showToast(err?.message || 'Failed to create team', 'error');
        return;
      }
      
      showToast('Could not generate unique slug after 100 attempts', 'error');
    } catch (e) {
      showToast(e.message || 'Failed to create team', 'error');
    } finally {
      setCreatingTeam(false);
    }
  };
  
  // Create org with duplicate slug handling
  const createOrg = async () => {
    if (!orgName.trim()) {
      showToast('Organization name is required', 'error');
      return;
    }
    setCreatingOrg(true);
    try {
      const t = authService.getToken();
      let slug = orgSlug.trim() || slugify(orgName);
      let attempt = 0;
      const maxAttempts = 100;
      
      while (attempt < maxAttempts) {
        const currentSlug = attempt === 0 ? slug : `${slug}-${String(attempt).padStart(2, '0')}`;
        const r = await fetch('/api/admin/orgs', { 
          method: 'POST', 
          headers: { Authorization: `Bearer ${t}`, 'Content-Type': 'application/json' }, 
          body: JSON.stringify({ name: orgName.trim(), slug: currentSlug }) 
        });
        
        if (r.ok) {
          showToast(`Organization "${orgName}" created successfully with slug: ${currentSlug}`, 'success');
          setOrgName('');
          setOrgSlug('');
          setOrgSlugManuallyEdited(false);
          return;
        }
        
        const err = await r.json().catch(() => ({}));
        // Check if error is due to duplicate slug
        if (err?.message?.toLowerCase().includes('slug already exists') || r.status === 400) {
          attempt++;
          continue;
        }
        
        // Other error - break and show message
        showToast(err?.message || 'Failed to create organization', 'error');
        return;
      }
      
      showToast('Could not generate unique slug after 100 attempts', 'error');
    } catch (e) {
      showToast(e.message || 'Failed to create organization', 'error');
    } finally {
      setCreatingOrg(false);
    }
  };

  const OcrDiagPanel = () => {
    const fileRef = _useRef(null);
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null);
    const [err, setErr] = useState('');
    const [langs, setLangs] = useState('eng');
    const [limit, setLimit] = useState(3);
    const run = async () => {
      try {
        setBusy(true); setErr(''); setResult(null);
        const f = fileRef.current?.files?.[0];
        if (!f) { setErr('Select a PDF'); return; }
        const t = authService.getToken();
        const fd = new FormData();
        fd.append('file', f);
        if (langs) fd.append('langs', langs);
        if (limit) fd.append('limit', String(limit));
        const resp = await fetch('/api/diagnostics/ocr-test', { method: 'POST', headers: { Authorization: `Bearer ${t}` }, body: fd });
        const j = await resp.json().catch(()=>({}));
        if (!resp.ok) { setErr(j?.message || 'Failed'); return; }
        setResult(j);
      } catch (e) {
        setErr(e.message || 'Failed');
      } finally { setBusy(false); }
    };
    return (
      <div style={{ border:'1px solid #e5e7eb', borderRadius:8, padding:12, background:'#fafafa' }}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          <div>
            <label style={{ fontWeight:600, display:'block', marginBottom:4 }}>PDF File</label>
            <input ref={fileRef} type="file" accept="application/pdf" />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 120px', gap:8, alignItems:'end' }}>
            <div>
              <label style={{ fontWeight:600, display:'block', marginBottom:4 }}>OCR Languages (comma)</label>
              <input type="text" value={langs} onChange={e=>setLangs(e.target.value)} placeholder="eng or eng,spa" style={{ width:'100%' }} />
            </div>
            <div>
              <label style={{ fontWeight:600, display:'block', marginBottom:4 }}>Page Limit</label>
              <input type="number" min={1} max={50} value={limit} onChange={e=>setLimit(parseInt(e.target.value||'1',10)||1)} style={{ width:'100%' }} />
            </div>
          </div>
        </div>
        <div style={{ marginTop:12, display:'flex', gap:8 }}>
          <button className="primary" onClick={run} disabled={busy}>Run OCR Test</button>
          {busy && <div style={{ alignSelf:'center', color:'#6b7280' }}>Running…</div>}
        </div>
        {err && <div style={{ marginTop:8, color:'#b00020' }}>{err}</div>}
        {result && (
          <div style={{ marginTop:12 }}>
            <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
              <span><strong>ok:</strong> {String(result.ok)}</span>
              <span><strong>length:</strong> {result.length}</span>
              <span><strong>ms:</strong> {result.ms}</span>
              {typeof result.pageCount === 'number' && <span><strong>pages:</strong> {result.pageCount}</span>}
              {typeof result.processed === 'number' && <span><strong>processed:</strong> {result.processed}</span>}
              {typeof result.nonEmptyPages === 'number' && <span><strong>non-empty:</strong> {result.nonEmptyPages}</span>}
            </div>
            {Array.isArray(result.perPage) && result.perPage.length > 0 && (
              <div style={{ marginTop:10 }}>
                <div style={{ fontWeight:600, marginBottom:6 }}>Per-page stats</div>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Page</th>
                      <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Length</th>
                      <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>ms</th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.perPage.map((p,i)=> (
                      <tr key={i}>
                        <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{p.page}</td>
                        <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{p.length}</td>
                        <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{p.ms}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {result.preview && (
              <div style={{ marginTop:10 }}>
                <div style={{ fontWeight:600, marginBottom:6 }}>Preview</div>
                <pre style={{ whiteSpace:'pre-wrap', maxHeight:200, overflowY:'auto', background:'#fff', padding:10, border:'1px solid #eee', borderRadius:6 }}>{result.preview}</pre>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const HeicDiagPanel = () => {
    const fileRef = _useRef(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');
    const [jpgB64, setJpgB64] = useState('');
    const [imgUrl, setImgUrl] = useState('');
    const run = async () => {
      try {
        setBusy(true); setErr(''); setJpgB64('');
        if (imgUrl) { try { URL.revokeObjectURL(imgUrl); } catch {} setImgUrl(''); }
        const f = fileRef.current?.files?.[0];
        if (!f) { setErr('Select a HEIC'); return; }
        const t = authService.getToken();
        const fd = new FormData(); fd.append('file', f);
        // Request blob back so we can display regardless of base64 issues
        const respBlob = await fetch('/api/diagnostics/heic-convert-blob', { method:'POST', headers:{ Authorization:`Bearer ${t}` }, body: fd });
        if (!respBlob.ok) {
          const j = await respBlob.json().catch(()=>({}));
          setErr(j?.message || 'Failed'); return;
        }
        const blob = await respBlob.blob();
        const url = URL.createObjectURL(blob);
        setImgUrl(url);
        // Also set base64 text for inspection
        try { const arrBuf = await blob.arrayBuffer(); const bytes = new Uint8Array(arrBuf); let bin=''; for (let i=0;i<bytes.length;i++){bin+=String.fromCharCode(bytes[i]);} setJpgB64(btoa(bin)); } catch {}
      } catch (e) {
        setErr(e.message || 'Failed');
      } finally { setBusy(false); }
    };
    React.useEffect(()=>{
      return () => { if (imgUrl) { try { URL.revokeObjectURL(imgUrl); } catch {} } };
    }, [imgUrl]);
    return (
      <div style={{ border:'1px solid #e5e7eb', borderRadius:8, padding:12, background:'#fafafa' }}>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <input ref={fileRef} type="file" accept="image/heic,.heic" />
          <button className="primary" onClick={run} disabled={busy}>Convert</button>
          {busy && <div style={{ color:'#6b7280' }}>Running…</div>}
        </div>
        {err && <div style={{ marginTop:8, color:'#b00020' }}>{err}</div>}
        {jpgB64 && (
          <div style={{ marginTop:8, display:'grid', gridTemplateColumns:'220px 1fr', gap:12, alignItems:'start' }}>
            <div>
              <div style={{ fontWeight:600, marginBottom:6 }}>Preview</div>
              <img alt="HEIC preview" src={imgUrl || (`data:image/jpeg;base64,${jpgB64}`)} style={{ maxWidth:200, maxHeight:200, border:'1px solid #eee', borderRadius:6, background:'#fff' }} />
            </div>
            <div>
              <div style={{ fontWeight:600, marginBottom:6 }}>JPG Base64</div>
              <pre style={{ whiteSpace:'pre-wrap', maxHeight:200, overflowY:'auto', background:'#fff', padding:8, border:'1px solid #eee', borderRadius:6 }}>{jpgB64}</pre>
            </div>
          </div>
        )}
      </div>
    );
  };

  const OcrDailyChart = () => {
    const [items, setItems] = useState([]);
    useEffect(() => { (async()=>{
      try { 
        const headers = authService.getAuthHeaders(); 
        const r = await fetch('/api/admin/metrics/ocr/daily?days=14', { headers: { ...headers }, credentials: 'include' }); 
        if (r.status === 401) {
          authService.logout();
          window.location.href = '/login';
          return;
        }
        if (!r.ok) return; 
        try {
          const j = await r.json(); 
          setItems(Array.isArray(j.items)?j.items:[]); 
        } catch {}
      } catch {} 
    })(); }, []);
    if (!items.length) return <div style={{ color:'#6b7280' }}>No data</div>;
    return (
      <div style={{ overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Date</th>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Extractions</th>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Chars</th>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Ms</th>
            </tr>
          </thead>
          <tbody>
            {items.map((x,i)=> (
              <tr key={i}>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.date}</td>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.count}</td>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.chars}</td>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.ms}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const OcrTopUsersTable = () => {
    const [items, setItems] = useState([]);
    useEffect(() => { (async()=>{
      try { 
        const headers = authService.getAuthHeaders(); 
        const r = await fetch('/api/admin/metrics/ocr/top-users?days=30&limit=10', { headers: { ...headers }, credentials: 'include' }); 
        if (r.status === 401) {
          authService.logout();
          window.location.href = '/login';
          return;
        }
        if (!r.ok) return; 
        try {
          const j = await r.json(); 
          setItems(Array.isArray(j.items)?j.items:[]); 
        } catch {}
      } catch {} 
    })(); }, []);
    if (!items.length) return <div style={{ color:'#6b7280' }}>No data</div>;
    return (
      <div style={{ overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>User</th>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Extractions</th>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Chars</th>
              <th style={{ textAlign:'left', borderBottom:'1px solid #eee', padding:'6px 4px' }}>Ms</th>
            </tr>
          </thead>
          <tbody>
            {items.map((x,i)=> (
              <tr key={i}>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.user}</td>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.count}</td>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.chars}</td>
                <td style={{ borderBottom:'1px solid #f3f4f6', padding:'6px 4px' }}>{x.ms}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const refreshAll = useCallback(async () => {
    const headers = authService.getAuthHeaders();
    const res = await fetch('/api/admin/metrics/overview', {
      headers: { ...headers },
      credentials: 'include'
    });
    if (!res.ok) {
      if (res.status === 401) {
        // Unauthorized - token is invalid, redirect to login
        authService.logout();
        window.location.href = '/login';
        return;
      }
      throw new Error('Failed to load admin metrics');
    }
    const data = await res.json().catch(() => ({}));
    setMetrics(data);

    const pRes = await fetch('/api/aipricing', { headers: { ...headers }, credentials: 'include' });
    if (pRes.status === 401) {
      authService.logout();
      window.location.href = '/login';
      return;
    }
    if (pRes.ok) {
      try {
        const pData = await pRes.json();
        setPricing(Array.isArray(pData) ? pData : []);
      } catch {}
    }

    const resUsers = await fetch(`/api/admin/users?page=${userPage.page}&pageSize=${userPage.pageSize}`, {
      headers: { ...headers },
      credentials: 'include'
    });
    if (resUsers.status === 401) {
      authService.logout();
      window.location.href = '/login';
      return;
    }
    if (resUsers.ok) {
      try {
        const up = await resUsers.json();
        setUserPage(up);
      } catch {}
    }

    const qs = new URLSearchParams();
    qs.set('page', flaggedPage.page);
    qs.set('pageSize', flaggedPage.pageSize);
    if (sinceDate) qs.set('since', sinceDate);
    const resFlag = await fetch('/api/admin/moderation/flagged?' + qs.toString(), {
      headers: { ...headers },
      credentials: 'include'
    });
    if (resFlag.status === 401) {
      authService.logout();
      window.location.href = '/login';
      return;
    }
    if (resFlag.ok) {
      try {
        const fl = await resFlag.json();
        setFlaggedPage(fl);
      } catch {}
    }

    // Load moderation settings
    try {
      const resMod = await fetch('/api/admin/moderation/settings', { headers: { ...headers }, credentials: 'include' });
      if (resMod.status === 401) {
        authService.logout();
        window.location.href = '/login';
        return;
      }
      if (resMod.ok) {
        try {
          const s = await resMod.json();
          setModSettings({
            hateWarn: Number(s.hateWarn || 0.4),
            hateBlock: Number(s.hateBlock || 0.8),
            violenceWarn: Number(s.violenceWarn || 0.4),
            violenceBlock: Number(s.violenceBlock || 0.8),
            selfHarmWarn: Number(s.selfHarmWarn || 0.4),
            selfHarmBlock: Number(s.selfHarmBlock || 0.8),
            blockPci: !!s.blockPci,
            blockCsam: !!s.blockCsam,
            forceDoNotStoreOnPiiWarn: !!s.forceDoNotStoreOnPiiWarn
          });
        } catch {}
      }
    } catch {}
  }, [userPage.page, userPage.pageSize, flaggedPage.page, flaggedPage.pageSize, sinceDate]); // setMetrics, setPricing, etc. are stable setState functions

  // Initial load on mount
  useEffect(() => {
    const load = async () => {
      try {
        const user = await authService.getUserInfo();
        const roles = (user.roles || []).map(r => r.toLowerCase());
        if (!roles.includes('admin')) {
          setError('Access denied: Admins only');
          return;
        }
        await refreshAll();
      } catch (e) {
        // If error is about unauthorized access (401), redirect to login
        if (e.message && (e.message.includes('401') || e.message.includes('Unauthorized') || e.message.includes('Failed to load admin metrics'))) {
          authService.logout();
          window.location.href = '/login';
          return;
        }
        setError(e.message || 'Failed to load admin');
      }
    };
    load();
  }, [refreshAll, setError]);

  // Auto-refresh moderation list when filters/paging change
  useEffect(() => {
    (async () => {
      try {
        const user = await authService.getUserInfo();
        const roles = (user.roles || []).map(r => r.toLowerCase());
        if (!roles.includes('admin')) return;
        await refreshAll();
      } catch {}
    })();
  }, [flaggedPage.page, flaggedPage.pageSize, sinceDate, refreshAll]);

  const goToPage = async (nextPage) => {
    try {
      const token = authService.getToken();
      const res = await fetch(`/api/admin/users?page=${nextPage}&pageSize=${userPage.pageSize}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const up = await res.json();
        setUserPage(up);
      }
    } catch {}
  };

  const changePageSize = async (e) => {
    const newSize = Number(e.target.value);
    try {
      const token = authService.getToken();
      const res = await fetch(`/api/admin/users?page=1&pageSize=${newSize}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const up = await res.json();
        setUserPage(up);
      }
    } catch {}
  };

  const [modSettings, setModSettings] = useState({ hateWarn:0.4, hateBlock:0.8, violenceWarn:0.4, violenceBlock:0.8, selfHarmWarn:0.4, selfHarmBlock:0.8, blockPci:true, blockCsam:true, forceDoNotStoreOnPiiWarn:false });
  const [savingMods, setSavingMods] = useState(false);
  const [modSaveMsg, setModSaveMsg] = useState('');
  const saveModSettings = async () => {
    try {
      setSavingMods(true);
      const t = authService.getToken();
      const body = { ...modSettings };
      const res = await fetch('/api/admin/moderation/settings', { method:'POST', headers:{ 'Authorization': `Bearer ${t}`, 'Content-Type':'application/json' }, body: JSON.stringify(body) });
      if (res.ok) {
        setModSaveMsg('Moderation settings saved.');
      } else {
        setModSaveMsg('Failed to save moderation settings.');
      }
    } catch {
      setModSaveMsg('Failed to save moderation settings.');
    } finally { setSavingMods(false); }
  };

  if (error) {
    return <div className="auth-container"><div className="auth-card"><div className="error-message">{error}</div></div></div>;
  }
  if (!metrics) {
    return <div className="auth-container"><div className="auth-card"><div className="loading-spinner">Loading...</div></div></div>;
  }

  return (
    <div className="admin-container">
      <div style={{ display:'flex', gap:0, marginBottom:12, borderBottom:'1px solid #e5e7eb', flexWrap:'wrap' }}>
        <button 
          style={getTabStyles(1, tab==='overview')}
          onMouseEnter={(e) => {
            if (tab !== 'overview') {
              Object.assign(e.currentTarget.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'overview') {
              restoreTabStyles(e.currentTarget, 1, false);
            }
          }}
          onClick={()=>setTab('overview')}
        >
          Overview
        </button>
        <button 
          style={getTabStyles(1, tab==='pricing')}
          onMouseEnter={(e) => {
            if (tab !== 'pricing') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'pricing') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('pricing')}
        >
          AI Pricing
        </button>
        <button 
          style={getTabStyles(1, tab==='models')}
          onMouseEnter={(e) => {
            if (tab !== 'models') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'models') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('models')}
        >
          Model Management
        </button>
        <button 
          style={getTabStyles(1, tab==='billing')}
          onMouseEnter={(e) => {
            if (tab !== 'billing') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'billing') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('billing')}
        >
          Billing
        </button>
        <button 
          style={getTabStyles(1, tab==='usage')}
          onMouseEnter={(e) => {
            if (tab !== 'usage') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'usage') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('usage')}
        >
          Usage and Tokens
        </button>
        <button 
          style={getTabStyles(1, tab==='users')}
          onMouseEnter={(e) => {
            if (tab !== 'users') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'users') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('users')}
        >
          Users
        </button>
        <button 
          style={getTabStyles(1, tab==='docs-edit')}
          onMouseEnter={(e) => {
            if (tab !== 'docs-edit') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'docs-edit') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('docs-edit')}
        >
          Docs Edit
        </button>
        <button 
          style={getTabStyles(1, tab==='categories')}
          onMouseEnter={(e) => {
            if (tab !== 'categories') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'categories') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('categories')}
        >
          Categories
        </button>
        <button 
          style={getTabStyles(1, tab==='diagnostics')}
          onMouseEnter={(e) => {
            if (tab !== 'diagnostics') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'diagnostics') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('diagnostics')}
        >
          Diagnostics
        </button>
        <button 
          style={getTabStyles(1, tab==='authentication')}
          onMouseEnter={(e) => {
            if (tab !== 'authentication') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'authentication') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('authentication')}
        >
          Authentication
        </button>
        <a
          href="/admin/access-logs"
          style={getTabStyles(1, false)}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, getTabHoverStyles(1));
          }}
          onMouseLeave={(e) => {
            restoreTabStyles(e.target, 1, false);
          }}
        >
          Access Logs
        </a>
      </div>
      <div style={{ display:'flex', gap:0, marginBottom:12, borderBottom:'1px solid #e5e7eb', flexWrap:'wrap' }}>
        <button 
          style={getTabStyles(1, tab==='script-permissions')}
          onMouseEnter={(e) => {
            if (tab !== 'script-permissions') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'script-permissions') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('script-permissions')}
        >
          Script Management & Governance
        </button>
        <button 
          style={{
            background: tab==='moderation-settings' ? '#fff' : 'transparent',
            color: tab==='moderation-settings' ? '#111827' : '#6b7280',
            border: 'none',
            borderBottom: tab==='moderation-settings' ? '2px solid #111827' : '2px solid transparent',
            padding: '8px 16px',
            cursor: 'pointer',
            fontWeight: tab==='moderation-settings' ? 600 : 400,
            fontSize: '14px'
          }}
          onClick={()=>setTab('moderation-settings')}
        >
          Moderation Settings
        </button>
        <button 
          style={{
            background: tab==='moderation' ? '#fff' : 'transparent',
            color: tab==='moderation' ? '#111827' : '#6b7280',
            border: 'none',
            borderBottom: tab==='moderation' ? '2px solid #111827' : '2px solid transparent',
            padding: '8px 16px',
            cursor: 'pointer',
            fontWeight: tab==='moderation' ? 600 : 400,
            fontSize: '14px'
          }}
          onClick={()=>setTab('moderation')}
        >
          Prompt Moderation
        </button>
        <button 
          style={{
            background: tab==='teams-orgs' ? '#fff' : 'transparent',
            color: tab==='teams-orgs' ? '#111827' : '#6b7280',
            border: 'none',
            borderBottom: tab==='teams-orgs' ? '2px solid #111827' : '2px solid transparent',
            padding: '8px 16px',
            cursor: 'pointer',
            fontWeight: tab==='teams-orgs' ? 600 : 400,
            fontSize: '14px'
          }}
          onClick={()=>setTab('teams-orgs')}
        >
          Teams/Orgs
        </button>
        <button 
          style={getTabStyles(1, tab==='registration')}
          onMouseEnter={(e) => {
            if (tab !== 'registration') {
              Object.assign(e.target.style, getTabHoverStyles(1));
            }
          }}
          onMouseLeave={(e) => {
            if (tab !== 'registration') {
              restoreTabStyles(e.target, 1, false);
            }
          }}
          onClick={()=>setTab('registration')}
        >
          Team/Org Registration
        </button>
      </div>

      {tab==='overview' && (
      <div className="admin-section">
        <h2 className="admin-header">Overview</h2>
        <div className="admin-stats-grid">
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.totalUsers}</div><div className="admin-stat-label">Total Users</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.newUsers7}</div><div className="admin-stat-label">New Users (7d)</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.newUsers30}</div><div className="admin-stat-label">New Users (30d)</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.totalGeneratedPrompts}</div><div className="admin-stat-label">Generated Prompts</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.totalSavedPrompts}</div><div className="admin-stat-label">Saved Prompts</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.ocrLast7Days ?? 0}</div><div className="admin-stat-label">OCR Extractions (7d)</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.ocrChars7 ?? 0}</div><div className="admin-stat-label">OCR Characters (7d)</div></div>
          <div className="admin-stat-item"><div className="admin-stat-number">{metrics.ocrMs7 ?? 0}</div><div className="admin-stat-label">OCR Milliseconds (7d)</div></div>
        </div>
        <div style={{ marginTop:16, display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, alignItems:'start' }}>
          <div>
            <h3 style={{ marginTop:0 }}>OCR Activity (last 14 days)</h3>
            <OcrDailyChart />
          </div>
          <div>
            <h3 style={{ marginTop:0 }}>Top OCR Users (30 days)</h3>
            <OcrTopUsersTable />
          </div>
        </div>
        {/* Enterprise LIMIT Max config (client-side, used by Mini‑BAIQL LIMIT cap) */}
        <div style={{ marginTop:16, border:'1px solid #e5e7eb', borderRadius:8, padding:12, background:'#fafafa' }}>
          <h3 style={{ marginTop:0 }}>Enterprise LIMIT Max (per minute)</h3>
          <p style={{ margin:'6px 0 12px 0', color:'#4b5563' }}>Sets the maximum LIMIT value allowed for Teams/Enterprise in Mini‑BAIQL. Stored locally.</p>
          <EnterpriseLimitLocal />
        </div>
      </div>
      )}

      {tab==='pricing' && (
      <div className="admin-section">
        <h2 className="admin-header">AI Pricing</h2>
        <div className="admin-controls" style={{gap:8, display:'flex', flexWrap:'wrap'}}>
          <button 
            onClick={()=>setEditingPrice({ id:0, provider:'OpenAI', model:'', inputPricePer1K:0, outputPricePer1K:0, currency:'USD', isActive:true })}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 4px rgba(102, 126, 234, 0.2)'
            }}
            onMouseEnter={(e)=>{
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
            }}
            onMouseLeave={(e)=>{
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
            }}
          >
            Add Price
          </button>
        </div>
        <div className="table-scroll">
          <table className="admin-table">
            <thead><tr><th>Provider</th><th>Model</th><th>In $/1K</th><th>Out $/1K</th><th>Curr</th><th>Active</th><th>Updated</th><th>Actions</th></tr></thead>
            <tbody>
              {pricing.map(p => (
                <tr key={p.id}>
                  <td>{p.provider}</td>
                  <td>{p.model}</td>
                  <td>${Number(p.inputPricePer1K).toFixed(6)}</td>
                  <td>${Number(p.outputPricePer1K).toFixed(6)}</td>
                  <td>{p.currency}</td>
                  <td>{p.isActive ? 'Yes' : 'No'}</td>
                  <td>{new Date(p.updatedAt).toLocaleString()}</td>
                  <td>
                    <button 
                      onClick={()=>setEditingPrice(p)}
                      style={{
                        padding: '6px 12px',
                        background: '#fff',
                        color: '#667eea',
                        border: '1.5px solid #667eea',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e)=>{
                        e.target.style.background = '#667eea';
                        e.target.style.color = '#fff';
                      }}
                      onMouseLeave={(e)=>{
                        e.target.style.background = '#fff';
                        e.target.style.color = '#667eea';
                      }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      )}
      {editingPrice && (
        <div className="modal-overlay">
          <div className="modal-content price-modal">
            <button className="modal-close" onClick={()=>setEditingPrice(null)}>×</button>
            <h3 style={{marginTop:0}}>{editingPrice.id ? 'Edit Price' : 'Add Price'}</h3>
            <div className="form-vertical">
              <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Provider</span>
                <input 
                  value={editingPrice.provider} 
                  onChange={e=>setEditingPrice({...editingPrice, provider:e.target.value})}
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Model</span>
                <input 
                  value={editingPrice.model} 
                  onChange={e=>setEditingPrice({...editingPrice, model:e.target.value})}
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Input $/1K</span>
                <input 
                  type="number" 
                  step="0.000001" 
                  value={editingPrice.inputPricePer1K} 
                  onChange={e=>setEditingPrice({...editingPrice, inputPricePer1K:parseFloat(e.target.value)})}
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Output $/1K</span>
                <input 
                  type="number" 
                  step="0.000001" 
                  value={editingPrice.outputPricePer1K} 
                  onChange={e=>setEditingPrice({...editingPrice, outputPricePer1K:parseFloat(e.target.value)})}
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', flexDirection:'column', gap:4 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Currency</span>
                <input 
                  value={editingPrice.currency} 
                  onChange={e=>setEditingPrice({...editingPrice, currency:e.target.value})}
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', alignItems:'center', gap:6, marginTop:8 }}>
                <input type="checkbox" checked={!!editingPrice.isActive} onChange={e=>setEditingPrice({...editingPrice, isActive:e.target.checked})} />
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Active</span>
              </label>
            </div>
            <div className="modal-actions" style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button 
                onClick={()=>setEditingPrice(null)}
                style={{
                  padding: '10px 20px',
                  background: '#fff',
                  color: '#6b7280',
                  border: '1.5px solid #e5e7eb',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e)=>{
                  e.target.style.background = '#f3f4f6';
                  e.target.style.borderColor = '#d1d5db';
                }}
                onMouseLeave={(e)=>{
                  e.target.style.background = '#fff';
                  e.target.style.borderColor = '#e5e7eb';
                }}
              >
                Cancel
              </button>
              <button 
                onClick={async()=>{
                  const t = authService.getToken();
                  const body = { provider: editingPrice.provider, model: editingPrice.model, inputPricePer1K: Number(editingPrice.inputPricePer1K||0), outputPricePer1K: Number(editingPrice.outputPricePer1K||0), currency: editingPrice.currency, isActive: !!editingPrice.isActive };
                  const res = await fetch('/api/aipricing/upsert', { method:'POST', headers:{ 'Authorization': `Bearer ${t}`, 'Content-Type':'application/json' }, body: JSON.stringify(body) });
                  if (res.ok) {
                    setEditingPrice(null);
                    await refreshAll();
                  }
                }}
                style={{
                  padding: '10px 20px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 4px rgba(102, 126, 234, 0.2)'
                }}
                onMouseEnter={(e)=>{
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                }}
                onMouseLeave={(e)=>{
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {tab==='users' && (
      <div className="admin-section">
        <h2 className="admin-header">Users</h2>
        <div className="dashboard-card" style={{ padding:8, marginBottom:12 }}>
          <h3 style={{ marginTop:0 }}>Invite User</h3>
          <InviteUserPanel onInvited={()=>refreshAll()} />
        </div>
        <div className="admin-controls">
          <label style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Rows:</span>
            <select 
              value={userPage.pageSize} 
              onChange={changePageSize}
              style={{
                padding: '8px 12px',
                border: '1.5px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s ease',
                background: '#fff',
                cursor: 'pointer',
                minWidth: '80px'
              }}
              onFocus={(e)=>{
                e.target.style.borderColor = '#667eea';
                e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
              }}
              onBlur={(e)=>{
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.boxShadow = 'none';
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
            </select>
          </label>
          <div className="admin-pager" style={{ display:'flex', gap:8, alignItems:'center' }}>
            <button 
              disabled={userPage.page<=1} 
              onClick={()=>goToPage(userPage.page-1)}
              style={{
                padding: '6px 12px',
                background: userPage.page<=1 ? '#f3f4f6' : '#fff',
                color: userPage.page<=1 ? '#9ca3af' : '#667eea',
                border: `1.5px solid ${userPage.page<=1 ? '#e5e7eb' : '#667eea'}`,
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                cursor: userPage.page<=1 ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                opacity: userPage.page<=1 ? 0.6 : 1
              }}
              onMouseEnter={(e)=>{
                if (userPage.page>1) {
                  e.target.style.background = '#667eea';
                  e.target.style.color = '#fff';
                }
              }}
              onMouseLeave={(e)=>{
                if (userPage.page>1) {
                  e.target.style.background = '#fff';
                  e.target.style.color = '#667eea';
                }
              }}
            >
              Prev
            </button>
            <span style={{ fontSize:14, color:'#374151' }}>Page {userPage.page} of {Math.max(1, Math.ceil(userPage.total / userPage.pageSize))}</span>
            <button 
              disabled={userPage.page >= Math.ceil(userPage.total / userPage.pageSize)} 
              onClick={()=>goToPage(userPage.page+1)}
              style={{
                padding: '6px 12px',
                background: userPage.page >= Math.ceil(userPage.total / userPage.pageSize) ? '#f3f4f6' : '#fff',
                color: userPage.page >= Math.ceil(userPage.total / userPage.pageSize) ? '#9ca3af' : '#667eea',
                border: `1.5px solid ${userPage.page >= Math.ceil(userPage.total / userPage.pageSize) ? '#e5e7eb' : '#667eea'}`,
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                cursor: userPage.page >= Math.ceil(userPage.total / userPage.pageSize) ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                opacity: userPage.page >= Math.ceil(userPage.total / userPage.pageSize) ? 0.6 : 1
              }}
              onMouseEnter={(e)=>{
                if (userPage.page < Math.ceil(userPage.total / userPage.pageSize)) {
                  e.target.style.background = '#667eea';
                  e.target.style.color = '#fff';
                }
              }}
              onMouseLeave={(e)=>{
                if (userPage.page < Math.ceil(userPage.total / userPage.pageSize)) {
                  e.target.style.background = '#fff';
                  e.target.style.color = '#667eea';
                }
              }}
            >
              Next
            </button>
          </div>
        </div>
        <div className="table-scroll">
          <table className="admin-table">
            <thead><tr><th>Email</th><th>Name</th><th>Roles</th><th>Registered</th><th>Last Login</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {userPage.users.map(u => (
                <tr key={u.id}>
                  <td>{u.email}</td>
                  <td>{(u.firstName||'') + ' ' + (u.lastName||'')}</td>
                  <td>{(u.roles||[]).join(', ')}</td>
                  <td>{new Date(u.registrationDate).toLocaleDateString()}</td>
                  <td>{u.lastLoginDate ? new Date(u.lastLoginDate).toLocaleDateString() : '-'}</td>
                  <td>{u.isLockedOut ? 'Suspended' : 'Active'}</td>
                  <td>
                    {u.isLockedOut ? (
                      <button 
                        onClick={async()=>{
                          const t = authService.getToken();
                          await fetch(`/api/admin/users/${u.id}/unsuspend`, { method:'POST', headers:{Authorization:`Bearer ${t}`}});
                          await refreshAll();
                        }}
                        style={{
                          padding: '6px 12px',
                          background: '#fff',
                          color: '#059669',
                          border: '1.5px solid #059669',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: 500,
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e)=>{
                          e.target.style.background = '#059669';
                          e.target.style.color = '#fff';
                        }}
                        onMouseLeave={(e)=>{
                          e.target.style.background = '#fff';
                          e.target.style.color = '#059669';
                        }}
                      >
                        Unsuspend
                      </button>
                    ) : (
                      <button 
                        onClick={async()=>{
                          const t = authService.getToken();
                          await fetch(`/api/admin/users/${u.id}/suspend`, { method:'POST', headers:{Authorization:`Bearer ${t}`}});
                          await refreshAll();
                        }}
                        style={{
                          padding: '6px 12px',
                          background: '#fff',
                          color: '#dc2626',
                          border: '1.5px solid #dc2626',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: 500,
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e)=>{
                          e.target.style.background = '#dc2626';
                          e.target.style.color = '#fff';
                        }}
                        onMouseLeave={(e)=>{
                          e.target.style.background = '#fff';
                          e.target.style.color = '#dc2626';
                        }}
                      >
                        Suspend
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      )}

      {tab==='categories' && (
      <div className="admin-section">
        <h2 className="admin-header">Categories</h2>
        <div className="table-scroll">
          <table className="admin-table">
            <thead><tr><th>Category</th><th>Generated</th><th>Saved</th></tr></thead>
            <tbody>
              {(metrics.categories || []).map(c => (
                <tr key={c.id}><td>{c.name}</td><td>{c.generatedCount}</td><td>{c.savedCount}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      )}

      {tab==='moderation' && (
      <div className="admin-section">
        <h2 className="admin-header">Prompt Moderation</h2>
        <div className="admin-controls">
          <label style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Since date:</span>
            <input 
              type="date" 
              value={sinceDate} 
              onChange={e=>setSinceDate(e.target.value)}
              style={{
                padding: '8px 12px',
                border: '1.5px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'all 0.2s ease',
                background: '#fff',
                cursor: 'pointer'
              }}
              onFocus={(e)=>{
                e.target.style.borderColor = '#667eea';
                e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
              }}
              onBlur={(e)=>{
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.boxShadow = 'none';
              }}
            />
          </label>
          <div className="admin-pager" style={{ display:'flex', gap:8, alignItems:'center' }}>
            <button 
              disabled={flaggedPage.page<=1} 
              onClick={()=>{setFlaggedPage(p=>({...p,page: Math.max(1, p.page-1)}));}}
              style={{
                padding: '6px 12px',
                background: flaggedPage.page<=1 ? '#f3f4f6' : '#fff',
                color: flaggedPage.page<=1 ? '#9ca3af' : '#667eea',
                border: `1.5px solid ${flaggedPage.page<=1 ? '#e5e7eb' : '#667eea'}`,
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                cursor: flaggedPage.page<=1 ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                opacity: flaggedPage.page<=1 ? 0.6 : 1
              }}
              onMouseEnter={(e)=>{
                if (flaggedPage.page>1) {
                  e.target.style.background = '#667eea';
                  e.target.style.color = '#fff';
                }
              }}
              onMouseLeave={(e)=>{
                if (flaggedPage.page>1) {
                  e.target.style.background = '#fff';
                  e.target.style.color = '#667eea';
                }
              }}
            >
              Prev
            </button>
            <span style={{ fontSize:14, color:'#374151' }}>Page {flaggedPage.page} of {Math.max(1, Math.ceil(flaggedPage.total / flaggedPage.pageSize))}</span>
            <button 
              disabled={flaggedPage.page >= Math.ceil(flaggedPage.total / flaggedPage.pageSize)} 
              onClick={()=>{setFlaggedPage(p=>({...p,page: p.page+1}));}}
              style={{
                padding: '6px 12px',
                background: flaggedPage.page >= Math.ceil(flaggedPage.total / flaggedPage.pageSize) ? '#f3f4f6' : '#fff',
                color: flaggedPage.page >= Math.ceil(flaggedPage.total / flaggedPage.pageSize) ? '#9ca3af' : '#667eea',
                border: `1.5px solid ${flaggedPage.page >= Math.ceil(flaggedPage.total / flaggedPage.pageSize) ? '#e5e7eb' : '#667eea'}`,
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                cursor: flaggedPage.page >= Math.ceil(flaggedPage.total / flaggedPage.pageSize) ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                opacity: flaggedPage.page >= Math.ceil(flaggedPage.total / flaggedPage.pageSize) ? 0.6 : 1
              }}
              onMouseEnter={(e)=>{
                if (flaggedPage.page < Math.ceil(flaggedPage.total / flaggedPage.pageSize)) {
                  e.target.style.background = '#667eea';
                  e.target.style.color = '#fff';
                }
              }}
              onMouseLeave={(e)=>{
                if (flaggedPage.page < Math.ceil(flaggedPage.total / flaggedPage.pageSize)) {
                  e.target.style.background = '#fff';
                  e.target.style.color = '#667eea';
                }
              }}
            >
              Next
            </button>
          </div>
        </div>
        <div className="table-scroll">
          <table className="admin-table">
            <thead><tr><th>Id</th><th>Title</th><th>Public</th><th>Flagged</th><th>Created</th><th>User</th><th>Codes</th><th>Notes</th><th>Actions</th></tr></thead>
            <tbody>
              {(flaggedPage.items || []).length === 0 && (
                <tr><td colSpan="7" style={{textAlign:'center'}}>No prompts</td></tr>
              )}
              {(flaggedPage.items || []).map(f => (
                <tr key={f.id}>
                  <td>{f.id}</td>
                  <td>
                    <button className="link-button" onClick={()=>setPreviewPromptId(f.id)} title="Preview prompt">{f.title}</button>
                  </td>
                  <td>{f.isPublic ? 'Yes' : 'No'}</td>
                  <td>{f.isFlagged ? 'Yes' : 'No'}</td>
                  <td>{new Date(f.createdDate).toLocaleDateString()}</td>
                  <td>{f.userEmail || '-'}</td>
                  <td>
                    <CodesDropdown id={f.id} value={f.moderationCodes||''} onSaved={()=>refreshAll()} />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      defaultValue={f.moderationNotes||''} 
                      placeholder="enter notes"
                      style={{
                        width:'220px',
                        padding: '8px 10px',
                        border: '1.5px solid #e5e7eb',
                        borderRadius: '6px',
                        fontSize: '13px',
                        transition: 'all 0.2s ease',
                        background: '#fff',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e)=>{
                        e.target.style.borderColor = '#667eea';
                        e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                      }}
                      onBlur={async(e)=>{
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.boxShadow = 'none';
                        const t = authService.getToken();
                        await fetch(`/api/admin/moderation/prompts/${f.id}/update`, { method:'POST', headers:{Authorization:`Bearer ${t}`, 'Content-Type':'application/json'}, body: JSON.stringify({ moderationNotes: e.target.value })});
                      }}
                    />
                  </td>
                  <td>
                    <button 
                      onClick={async()=>{
                        const t = authService.getToken();
                        await fetch(`/api/admin/moderation/prompts/${f.id}/toggle-flag`, { method:'POST', headers:{Authorization:`Bearer ${t}`}});
                        await refreshAll();
                      }}
                      style={{
                        padding: '6px 12px',
                        background: f.isFlagged ? '#fff' : '#fff',
                        color: f.isFlagged ? '#059669' : '#dc2626',
                        border: f.isFlagged ? '1.5px solid #059669' : '1.5px solid #dc2626',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e)=>{
                        e.target.style.background = f.isFlagged ? '#059669' : '#dc2626';
                        e.target.style.color = '#fff';
                      }}
                      onMouseLeave={(e)=>{
                        e.target.style.background = '#fff';
                        e.target.style.color = f.isFlagged ? '#059669' : '#dc2626';
                      }}
                    >
                      {f.isFlagged ? 'Unflag' : 'Flag'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {previewPromptId && (
          <PromptPreviewModal id={previewPromptId} onClose={()=>setPreviewPromptId(null)} />
        )}
      </div>
      )}

      {tab==='moderation-settings' && (
      <div className="admin-section">
        <h2 className="admin-header">Moderation Settings</h2>
        <p style={{ marginTop:0, color:'#6b7280' }}>Global thresholds for OpenAI moderation categories (UI only; not wired yet).</p>
        <div className="form-vertical">
          <label>Hate warn threshold ({modSettings.hateWarn.toFixed(2)})
            <input type="range" min="0" max="1" step="0.01" value={modSettings.hateWarn} onChange={e=>setModSettings(s=>({...s, hateWarn: Number(e.target.value)}))} />
          </label>
          <label>Hate block threshold ({modSettings.hateBlock.toFixed(2)})
            <input type="range" min="0" max="1" step="0.01" value={modSettings.hateBlock} onChange={e=>setModSettings(s=>({...s, hateBlock: Number(e.target.value)}))} />
          </label>
          <label>Violence warn threshold ({modSettings.violenceWarn.toFixed(2)})
            <input type="range" min="0" max="1" step="0.01" value={modSettings.violenceWarn} onChange={e=>setModSettings(s=>({...s, violenceWarn: Number(e.target.value)}))} />
          </label>
          <label>Violence block threshold ({modSettings.violenceBlock.toFixed(2)})
            <input type="range" min="0" max="1" step="0.01" value={modSettings.violenceBlock} onChange={e=>setModSettings(s=>({...s, violenceBlock: Number(e.target.value)}))} />
          </label>
          <label>Self-harm warn threshold ({modSettings.selfHarmWarn.toFixed(2)})
            <input type="range" min="0" max="1" step="0.01" value={modSettings.selfHarmWarn} onChange={e=>setModSettings(s=>({...s, selfHarmWarn: Number(e.target.value)}))} />
          </label>
          <label>Self-harm block threshold ({modSettings.selfHarmBlock.toFixed(2)})
            <input type="range" min="0" max="1" step="0.01" value={modSettings.selfHarmBlock} onChange={e=>setModSettings(s=>({...s, selfHarmBlock: Number(e.target.value)}))} />
          </label>
          <div style={{border:'1px solid #e5e7eb', borderRadius:8, padding:12, marginTop:12}}>
            <label style={{display:'block', margin:'6px 0'}}><input type="checkbox" checked={modSettings.blockPci} onChange={e=>setModSettings(s=>({...s, blockPci: e.target.checked}))} /> Block PCI (payment card)</label>
            <label style={{display:'block', margin:'6px 0'}}><input type="checkbox" checked={modSettings.blockCsam} onChange={e=>setModSettings(s=>({...s, blockCsam: e.target.checked}))} /> Hard-block CSAM indicators</label>
            <label style={{display:'block', margin:'6px 0'}}><input type="checkbox" checked={modSettings.forceDoNotStoreOnPiiWarn} onChange={e=>setModSettings(s=>({...s, forceDoNotStoreOnPiiWarn: e.target.checked}))} /> Force DoNotStore on PII warn</label>
          </div>
          <div className="admin-controls" style={{ justifyContent:'flex-end' }}>
            <button 
              onClick={saveModSettings} 
              disabled={savingMods}
              style={{
                padding: '12px 24px',
                background: savingMods ? '#9ca3af' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: savingMods ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: savingMods ? 'none' : '0 2px 4px rgba(102, 126, 234, 0.2)',
                opacity: savingMods ? 0.7 : 1
              }}
              onMouseEnter={(e)=>{
                if (!savingMods) {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                }
              }}
              onMouseLeave={(e)=>{
                if (!savingMods) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
                }
              }}
            >
              {savingMods ? 'Saving…' : 'Save'}
            </button>
          </div>
          {modSaveMsg && (<div style={{ marginTop:8, color: modSaveMsg.toLowerCase().includes('saved') ? '#065f46' : 'crimson' }}>{modSaveMsg}</div>)}
        </div>
      </div>
      )}

      {tab==='models' && (
      <AdminModels />
      )}

      {tab==='usage' && (
        <AdminUsage />
      )}

      {tab==='billing' && (
        <AdminBilling />
      )}

      {tab==='docs-edit' && (
        <AdminDocsEdit />
      )}

      {tab==='registration' && (
        <AdminRegistration />
      )}

      {tab==='teams-orgs' && (
      <div className="admin-section">
        <h2 className="admin-header">Teams & Organizations</h2>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          {/* Row 1: Create */}
          <div className="dashboard-card" style={{ padding:8 }}>
            <h3 style={{ marginTop:0 }}>Create Team</h3>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'end' }}>
              <label style={{ display:'flex', flexDirection:'column', gap:4, flex:1 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Team Name</span>
                <input 
                  value={teamName}
                  onChange={(e) => setTeamName(e.target.value)}
                  placeholder="Team Name"
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', flexDirection:'column', gap:4, flex:1 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Team Slug</span>
                <input 
                  value={teamSlug}
                  onChange={(e) => {
                    setTeamSlug(e.target.value);
                    setTeamSlugManuallyEdited(true);
                  }}
                  placeholder="team-slug (auto-generated)"
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <button 
                onClick={createTeam}
                disabled={creatingTeam}
                style={{
                  padding: '10px 20px',
                  background: creatingTeam ? '#9ca3af' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: creatingTeam ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: creatingTeam ? 'none' : '0 2px 4px rgba(102, 126, 234, 0.2)',
                  height: 'fit-content',
                  opacity: creatingTeam ? 0.7 : 1
                }}
                onMouseEnter={(e)=>{
                  if (!creatingTeam) {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                  }
                }}
                onMouseLeave={(e)=>{
                  if (!creatingTeam) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
                  }
                }}
              >
                {creatingTeam ? 'Creating…' : 'Create'}
              </button>
            </div>
          </div>
          <div className="dashboard-card" style={{ padding:8 }}>
            <h3 style={{ marginTop:0 }}>Create Organization</h3>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'end' }}>
              <label style={{ display:'flex', flexDirection:'column', gap:4, flex:1 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Org Name</span>
                <input 
                  value={orgName}
                  onChange={(e) => setOrgName(e.target.value)}
                  placeholder="Org Name"
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <label style={{ display:'flex', flexDirection:'column', gap:4, flex:1 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Org Slug</span>
                <input 
                  value={orgSlug}
                  onChange={(e) => {
                    setOrgSlug(e.target.value);
                    setOrgSlugManuallyEdited(true);
                  }}
                  placeholder="org-slug (auto-generated)"
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <button 
                onClick={createOrg}
                disabled={creatingOrg}
                style={{
                  padding: '10px 20px',
                  background: creatingOrg ? '#9ca3af' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: creatingOrg ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: creatingOrg ? 'none' : '0 2px 4px rgba(102, 126, 234, 0.2)',
                  height: 'fit-content',
                  opacity: creatingOrg ? 0.7 : 1
                }}
                onMouseEnter={(e)=>{
                  if (!creatingOrg) {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                  }
                }}
                onMouseLeave={(e)=>{
                  if (!creatingOrg) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
                  }
                }}
              >
                {creatingOrg ? 'Creating…' : 'Create'}
              </button>
            </div>
          </div>
          {/* Row 2: Members */}
          <div className="dashboard-card" style={{ padding:8 }}>
            <h3 style={{ marginTop:0 }}>Team Members</h3>
            <p style={{ margin:'6px 0 10px 0', color:'#4b5563' }}>Manage team members from the Teams page.</p>
            <a className="link-button" href="/teams">Go to Teams ›</a>
          </div>
          <div className="dashboard-card" style={{ padding:8 }}>
            <h3 style={{ marginTop:0 }}>Organization Members</h3>
            <p style={{ margin:'6px 0 10px 0', color:'#4b5563' }}>Manage organization members from the Enterprise page.</p>
            <a className="link-button" href="/enterprise">Go to Enterprise ›</a>
          </div>
          {/* Row 3: Deactivate */}
          <div className="dashboard-card" style={{ padding:8 }}>
            <h3 style={{ marginTop:0 }}>Deactivate Team</h3>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'end' }}>
              <label style={{ display:'flex', flexDirection:'column', gap:4, flex:1 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Team Id</span>
                <input 
                  id="deactTeamId" 
                  placeholder="Team Id"
                  type="text"
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <button 
                onClick={async()=>{
                  const teamIdVal = document.getElementById('deactTeamId').value.trim();
                  if (!teamIdVal) {
                    showToast('Enter a valid Team Id', 'error');
                    return;
                  }
                  try {
                    const t = authService.getToken();
                    const r = await fetch(`/api/admin/registration/team/${teamIdVal}/deactivate`, { method:'POST', headers:{ Authorization:`Bearer ${t}` } });
                    if (r.ok) {
                      showToast('Team deactivated successfully', 'success');
                      document.getElementById('deactTeamId').value = '';
                    } else {
                      const err = await r.json().catch(() => ({}));
                      showToast(err?.message || 'Failed to deactivate team', 'error');
                    }
                  } catch (e) {
                    showToast(e.message || 'Failed to deactivate team', 'error');
                  }
                }}
                style={{
                  padding: '10px 20px',
                  background: '#fff',
                  color: '#dc2626',
                  border: '1.5px solid #dc2626',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  height: 'fit-content'
                }}
                onMouseEnter={(e)=>{
                  e.target.style.background = '#dc2626';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e)=>{
                  e.target.style.background = '#fff';
                  e.target.style.color = '#dc2626';
                }}
              >
                Deactivate
              </button>
            </div>
          </div>
          <div className="dashboard-card" style={{ padding:8 }}>
            <h3 style={{ marginTop:0 }}>Deactivate Organization</h3>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'end' }}>
              <label style={{ display:'flex', flexDirection:'column', gap:4, flex:1 }}>
                <span style={{ fontSize:14, fontWeight:500, color:'#374151' }}>Org Id</span>
                <input 
                  id="deactOrgId" 
                  placeholder="Org Id"
                  type="text"
                  style={{
                    padding: '10px 12px',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s ease',
                    background: '#fff',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e)=>{
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e)=>{
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </label>
              <button 
                onClick={async()=>{
                  const orgIdVal = document.getElementById('deactOrgId').value.trim();
                  if (!orgIdVal) {
                    showToast('Enter a valid Org Id', 'error');
                    return;
                  }
                  try {
                    const t = authService.getToken();
                    const r = await fetch(`/api/admin/registration/org/${orgIdVal}/deactivate`, { method:'POST', headers:{ Authorization:`Bearer ${t}` } });
                    if (r.ok) {
                      showToast('Organization deactivated successfully', 'success');
                      document.getElementById('deactOrgId').value = '';
                    } else {
                      const err = await r.json().catch(() => ({}));
                      showToast(err?.message || 'Failed to deactivate organization', 'error');
                    }
                  } catch (e) {
                    showToast(e.message || 'Failed to deactivate organization', 'error');
                  }
                }}
                style={{
                  padding: '10px 20px',
                  background: '#fff',
                  color: '#dc2626',
                  border: '1.5px solid #dc2626',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  height: 'fit-content'
                }}
                onMouseEnter={(e)=>{
                  e.target.style.background = '#dc2626';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e)=>{
                  e.target.style.background = '#fff';
                  e.target.style.color = '#dc2626';
                }}
              >
                Deactivate
              </button>
            </div>
          </div>
        </div>
        <Toast show={toast.show} type={toast.type} message={toast.message} onClose={hideToast} />
      </div>
      )}
      {tab==='diagnostics' && (
        <div className="admin-section">
          <h2 className="admin-header">Diagnostics</h2>
          <div style={{ display:'grid', gap:16 }}>
            <div>
              <h3 style={{ marginTop:0 }}>OCR Test (PDF)</h3>
              <OcrDiagPanel />
            </div>
            <div>
              <h3 style={{ marginTop:0 }}>HEIC → JPG Test</h3>
              <HeicDiagPanel />
            </div>
          </div>
        </div>
      )}
      {tab==='authentication' && (
        <div className="admin-section">
          <h2 className="admin-header">Authentication Settings</h2>
          <AppPasswordPolicy />
        </div>
      )}
      {tab==='script-permissions' && (
        <ScriptGovernanceTab scopeType="Global" scopeId={null} />
      )}
    </div>
  );
};

export default Admin;


